import React from 'react';
import SectionHeading from '../../SectionHeading';
import Spacing from '../../Spacing';
import Accordion from '../../Accordion';

export default function FaqSectionStyle3({
  data,
  sectionTitle,
  sectionTitleUp,
}) {
  return (
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <SectionHeading title={sectionTitle} titleUp={sectionTitleUp} center />
          <Spacing md="40" lg="0" />
        </div>
        <div className="col-lg-12">
       
          <Accordion variant="cs_style1 cs_type_2" data={data} />
        </div>
      </div>
    </div>
  );
}
